import axios from "axios";
import { uiAction } from "./ui-gemini";

export const adminGetConfig = async (id, status) => {
  const url = `/api/admin/config`;
  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminUpdateConfig = async (data) => {
  const url = `/api/admin/config`;
  return axios(url, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const getConfig = () => {
  return (dispatch) => {
    const url = `/api/config`;

    axios(url, {
      method: "GET",
      // Public endpoint: don't send cookies to avoid accidental 401 for guests
      withCredentials: false,
    })
      .then((response) => {
        if (response.data?.data) {
          dispatch(uiAction.setConfig(response.data?.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
